export default __webpack_public_path__ + "static/media/logo.9ff586e4.png";